// Module
var code = "<p>Do you have multiple payments to multiple lenders each month? Consider consolidating your student loans to make one payment to one lender.</p> <p><a class=\"more-link\" href=\"/manage/consolidation\">Learn More About Consolidation</a></p> ";
// Exports
export default code;